import React from 'react'
import List from '@mui/material/List'
import { ListItem, ListItemText } from '@mui/material'
import { ModifierNumber } from '../ModifierNumber/ModifierNumber'

export const ModifierList: React.FC<{
  entries: [string, number][]
  translation: { [key: string]: string }
}> = ({ entries, translation }) => {
  return (
    <List sx={{ padding: '0px', margin: '0px' }}>
      {entries
        .filter(s => Math.abs(s[1]) > 0.01)
        .filter(s => s[0] !== 'id')
        .map(stat => (
          <ListItem sx={{ padding: '0px' }} key={stat[0]}>
            <ListItemText primary={translation[stat[0]] || stat[0]} />
            <ModifierNumber value={stat[1]} />
          </ListItem>
        ))}
    </List>
  )
}
